import { useQuery } from "@tanstack/react-query";

import type {
  GetAllActiveCountriesResponseType,
  GetAllActiveEmploymentTypesResponseType,
  GetAllActiveProfessionTypesResponseType,
  GetAllBankingInsurersResponseType,
  GetCitiesByCountryProductResponseType,
} from "@pbz/schema/master";

import { QUERY_KEYS } from "@/utils/constants";
import { orpc } from "@/utils/orpc-client";

export function useGetCities(productId: number) {
  return useQuery<GetCitiesByCountryProductResponseType>(
    orpc.master.getCitiesByCountryProduct.queryOptions({
      input: { countryProductId: productId },
      queryKey: [QUERY_KEYS.CITIES, productId],
    }),
  );
}

export function useGetCountries() {
  return useQuery<GetAllActiveCountriesResponseType>(
    orpc.master.getAllActiveCountries.queryOptions({
      input: {},
      queryKey: [QUERY_KEYS.COUNTRIES],
    }),
  );
}

export function useGetEmploymentTypes() {
  return useQuery<GetAllActiveEmploymentTypesResponseType>(
    orpc.master.getAllActiveEmploymentTypes.queryOptions({
      input: {},
      queryKey: [QUERY_KEYS.EMPLOYMENT_TYPES],
    }),
  );
}

export function useGetProfessionTypes() {
  return useQuery<GetAllActiveProfessionTypesResponseType>(
    orpc.master.getAllActiveProfessionTypes.queryOptions({
      input: {},
      queryKey: [QUERY_KEYS.PROFESSION_TYPES],
    }),
  );
}

export function useGetBankingInsurers() {
  return useQuery<GetAllBankingInsurersResponseType>(
    orpc.master.getAllBankingInsurers.queryOptions({
      input: {},
      queryKey: [QUERY_KEYS.BANKING_INSURERS],
    }),
  );
}
